/**
 * Destinations for the shared public header (Público A).
 *
 * Desktop renders `PUBLIC_HEADER_LINKS` only. The narrow dialog renders
 * those five and then `PUBLIC_HEADER_CREATE_ACCOUNT`. Criar conta is not
 * a desktop link. The landing header does not read this module.
 */

export type PublicHeaderLink = {
  /** Visible label and accessible name. */
  label: string;
  /** Router path. Hash links are absolute (`/#…`), not in-page `#…`. */
  to: string;
};

export const PUBLIC_HEADER_LINKS: readonly PublicHeaderLink[] = [
  { label: "Planos", to: "/planos" },
  { label: "Como funciona", to: "/#como-funciona" },
  { label: "Dúvidas", to: "/#duvidas" },
  { label: "Contato", to: "/contato" },
  { label: "Entrar", to: "/login" },
];

/** Menu-only. Not rendered in the desktop row. */
export const PUBLIC_HEADER_CREATE_ACCOUNT: PublicHeaderLink = {
  label: "Criar conta",
  to: "/registro",
};

/** `aria-controls` on Abrir menu, `id` on the dialog. */
export const PUBLIC_HEADER_MENU_ID = "public-header-menu";

/**
 * Class names shared by PublicHeader.tsx and PublicHeader.css.
 * Both files use these strings and no others.
 */
export const publicHeaderClass = {
  root: "public-header",
  bar: "public-header__bar",
  spacer: "public-header__spacer",
  nav: "public-header__nav",
  link: "public-header__link",
  menu: "public-header__menu",
  dialog: "public-header__dialog",
  dialogNav: "public-header__dialog-nav",
  item: "public-header__item",
  cta: "public-header__cta",
  decor: "public-header__decor",
  decorTeal: "public-header__decor-teal",
  decorEmerald: "public-header__decor-emerald",
  decorAmber: "public-header__decor-amber",
  decorSky: "public-header__decor-sky",
} as const;

/**
 * True when `to` is the page the visitor is on.
 * Hash targets match only on `/` with that hash. Other targets match the
 * path or a path beneath it.
 */
export function isPublicHeaderLinkCurrent(
  to: string,
  pathname: string,
  hash: string,
): boolean {
  if (to.startsWith("/#")) {
    return pathname === "/" && hash === to.slice(1);
  }
  if (to === "/") return pathname === "/";
  return pathname === to || pathname.startsWith(`${to}/`);
}
